import { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { api } from "../lib/api";
import StatusBadge from "../components/StatusBadge";

const CATEGORIES = ["all", "Waterjet", "Airjet", "Rapier", "Spare Parts", "Technical Services"];

function formatDate(iso) {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

export default function AdminMembers() {
    const [members, setMembers] = useState([]);
    const [category, setCategory] = useState("all");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const url = "/admin/members" + (category !== "all" ? `?category=${encodeURIComponent(category)}` : "");
        api.get(url).then((res) => setMembers(res.data)).finally(() => setLoading(false));
    }, [category]);

    return (
        <AdminLayout>
            <div className="mb-8 flex items-end justify-between" data-testid="members-page">
                <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-2">Approved Members</div>
                    <h1 className="font-display text-3xl font-bold text-[#0F172A] tracking-tight">Members Directory</h1>
                </div>
                <div className="text-sm text-[#64748B] tabular">{members.length} members</div>
            </div>

            <div className="bg-white border border-[#E2E8F0] mb-px p-4">
                <div className="flex gap-1 flex-wrap" data-testid="category-filter">
                    {CATEGORIES.map((c) => (
                        <button
                            key={c} onClick={() => setCategory(c)}
                            data-testid={`filter-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}
                            className={`px-4 py-2 text-xs uppercase tracking-[0.1em] font-medium transition-colors ${category === c ? "bg-[#0F172A] text-white" : "bg-white text-[#64748B] hover:text-[#0F172A] border border-[#E2E8F0]"}`}
                        >{c === "all" ? "All Categories" : c}</button>
                    ))}
                </div>
            </div>

            <div className="bg-white border border-[#E2E8F0]">
                {loading ? (
                    <div className="p-10 text-center text-sm text-[#64748B]">Loading…</div>
                ) : members.length === 0 ? (
                    <div className="p-16 text-center text-sm text-[#64748B]" data-testid="members-empty">No members in this category yet</div>
                ) : (
                    <table className="w-full text-sm" data-testid="members-table">
                        <thead className="text-xs uppercase tracking-wide text-[#64748B] bg-[#F8F9FA]">
                            <tr>
                                <th className="text-left px-6 py-3 font-medium">Member ID</th>
                                <th className="text-left px-6 py-3 font-medium">Company</th>
                                <th className="text-left px-6 py-3 font-medium">Contact</th>
                                <th className="text-left px-6 py-3 font-medium">Category</th>
                                <th className="text-left px-6 py-3 font-medium">City</th>
                                <th className="text-left px-6 py-3 font-medium">Status</th>
                                <th className="text-left px-6 py-3 font-medium">Joined</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-[#E2E8F0]">
                            {members.map((m) => (
                                <tr key={m.id} data-testid={`member-row-${m.id}`} className="hover:bg-[#F8F9FA]">
                                    <td className="px-6 py-4 font-mono text-xs">{m.member_id || "—"}</td>
                                    <td className="px-6 py-4 font-medium">{m.company_name}</td>
                                    <td className="px-6 py-4 text-[#64748B]">{m.email}</td>
                                    <td className="px-6 py-4 text-[#64748B]">{m.category}</td>
                                    <td className="px-6 py-4 text-[#64748B]">{m.city}</td>
                                    <td className="px-6 py-4"><StatusBadge status="active" /></td>
                                    <td className="px-6 py-4 text-[#64748B] tabular">{formatDate(m.reviewed_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </AdminLayout>
    );
}
